import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
import "./index.scss";

const CustomerDetails = () => {
  const location = useLocation();
  const formData = location.state?.formData || {};
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const renderUploadedImages = () => {
    return Object.keys(formData).map((key) => {
      const formattedKey = key.replace(/_/g, " ").toUpperCase();
      if (formData[key] instanceof File) {
        const fileUrl = URL.createObjectURL(formData[key]);
        return (
          <div className="custom-col mb-3" key={key}>
            <div className="detail-item">
              <span className="detail-label">{formattedKey}:</span>
              <img
                src={fileUrl}
                alt={key}
                className="uploaded-image"
                height={200}
                width={200}
                onClick={() => handleImageClick(fileUrl)}
                style={{ cursor: "pointer" }}
              />
            </div>
          </div>
        );
      }
      return null;
    });
  };

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedImage(null);
  };

  const renderCheckboxSection = () => {
    return (
      <div className="section">
        <h3>Permissions</h3>
        <div className="row">
          {Object.keys(formData).map((key) => {
            const formattedKey = key.replace(/_/g, " ").toUpperCase();
            if (typeof formData[key] === "boolean") {
              return (
                <div className="custom-col mb-3" key={key}>
                  <div className="detail-item">
                    <span className="detail-label">{formattedKey}:</span>
                    <input
                      type="checkbox"
                      checked={formData[key]}
                      className="form-check-input"
                      readOnly
                    />
                  </div>
                </div>
              );
            }
            return null;
          })}
        </div>
      </div>
    );
  };

  const renderPersonalDetailsSection = () => {
    return (
      <div className="section">
        <h3>Personal Details</h3>
        <div className="row">
          {Object.keys(formData).map((key) => {
            const formattedKey = key.replace(/_/g, " ").toUpperCase();
            if (
              !(formData[key] instanceof File) &&
              !Array.isArray(formData[key]) &&
              typeof formData[key] !== "boolean" &&
              typeof formData[key] !== "object"
            ) {
              return (
                <div className="custom-col mb-3" key={key}>
                  <div className="detail-item">
                    <span className="detail-label">{formattedKey}:</span>
                    <p>{formData[key]}</p>
                  </div>
                </div>
              );
            }
            return null;
          })}
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="backbutton mt-2 mb-2">
        <img src={backicon} alt="back" />
        <span className="backbtntitle">Customer Details</span>
      </div>
      <div className="container mt-4">
        {renderPersonalDetailsSection()}

        <div className="section">
          <h3>Uploaded Images</h3>
          <div className="row">{renderUploadedImages()}</div>
        </div>

        {renderCheckboxSection()}
      </div>

      {/* Modal */}
      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Image Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedImage && <img src={selectedImage} alt="Preview" className="img-fluid" />}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CustomerDetails;
